import {
    apiRequest,
    laporanPenilaianSKPList,
    laporanPenilaianSKPActive,
    laporanPenilaianSKPInactive,
} from "../../../../../services/adapters/kepegawaian/laporanPenilaianSKPService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", laporanPenilaianSKPList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", laporanPenilaianSKPInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", laporanPenilaianSKPActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository